import React, {useState} from "react";
import "./App.css";
import Clock from "./components/clock/Clock";
import Menu from "./components/menu/Menu";

const App: React.FC = () => {
    const [wrapperClass, setWrapperClass] = useState("wrapper");
    
    const switchToBack = () => {
        setWrapperClass('wrapperBack');
    };

    const switchToFront = () => {
        setWrapperClass('wrapper');
    };

    return (
        <>
            <div className={wrapperClass}>
                <div className="card">
                    <div className="front" onClick={switchToBack}>
                        <Clock/>
                    </div>
                    <div className="back">
                        <Menu toggleClockView={switchToFront}/>
                    </div>
                </div>
            </div>
        </>
    );
};

export default App;
